var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',_vm._b({ref:"input",staticClass:"input-sigarus-date-picker",attrs:{"type":"date","clearable":false,"value-format":"dd/MM/yyyy","picker-options":{firstDayOfWeek: 1}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-date-picker',{..._vm.$attrs, ..._vm.$props},false))
}
var staticRenderFns = []

export { render, staticRenderFns }